function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "icon-state-normal"
}, React.createElement("path", {
  d: "M256 1C115.2 1 1 115.2 1 256s114.2 255 255 255 255-114.2 255-255S396.8 1 256 1zm0 494.7C123.6 495.7 16.3 388.4 16.3 256 16.3 123.6 123.6 16.3 256 16.3S495.7 123.6 495.7 256c0 132.4-107.3 239.7-239.7 239.7z"
}), React.createElement("path", {
  d: "M256 156c-55.2 0-100 45-100 100s44.8 100 100 100c55 0 100-45 100-100s-45-100-100-100zm0 183.8c-46.2 0-83.8-37.6-83.8-83.8 0-46.2 37.6-83.8 83.8-83.8 46.2 0 83.8 37.6 83.8 83.8 0 46.2-37.6 83.8-83.8 83.8zm0 0"
}), React.createElement("path", {
  d: "M256 194.4c-34 0-61.6 27.7-61.6 61.6 0 34 27.7 61.6 61.6 61.6 34 0 61.6-27.6 61.6-61.6S290 194.4 256 194.4zm0 107c-25 0-45.4-20.4-45.4-45.4s20.4-45.4 45.4-45.4 45.4 20.4 45.4 45.4-20.4 45.4-45.4 45.4zm0 0"
}), React.createElement("path", {
  d: "M279.8 256c0 13.2-10.7 23.8-23.8 23.8-13.2 0-23.8-10.6-23.8-23.8 0-13.2 10.6-23.8 23.8-23.8 13 0 23.8 10.6 23.8 23.8zm0 0"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "icon-state-hover"
}, React.createElement("path", {
  d: "M256 210.6c-25 0-45.4 20.4-45.4 45.4s20.4 45.4 45.4 45.4 45.4-20.4 45.4-45.4-20.4-45.4-45.4-45.4zm0 69.2c-13.2 0-23.8-10.6-23.8-23.8 0-13.2 10.6-23.8 23.8-23.8 13 0 23.8 10.6 23.8 23.8 0 13.2-10.7 23.8-23.8 23.8z"
}), React.createElement("path", {
  d: "M256 172.2c-46.2 0-83.8 37.6-83.8 83.8 0 46.2 37.6 83.8 83.8 83.8 46.2 0 83.8-37.6 83.8-83.8 0-46.2-37.6-83.8-83.8-83.8zm0 145.4c-34 0-61.6-27.6-61.6-61.6s27.7-61.6 61.6-61.6c34 0 61.6 27.7 61.6 61.6 0 34-27.7 61.6-61.6 61.6z"
}), React.createElement("path", {
  d: "M256 1C115.2 1 1 115.2 1 256s114.2 255 255 255 255-114.2 255-255S396.8 1 256 1zm0 355c-55.2 0-100-45-100-100s44.8-100 100-100c55 0 100 45 100 100s-45 100-100 100z"
}));

function SvgCoaching(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 512 512",
    preserveAspectRatio: "xMidYMid",
    fill: "currentcolor",
    "data-qa": "svg",
    "aria-labelledby": titleId
  }, props), title ? React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

export default SvgCoaching;